import { render, staticRenderFns } from "./DeRepartizat.vue?vue&type=template&id=7a33c040&scoped=true&"
import script from "./DeRepartizat.ts?vue&type=script&lang=ts&"
export * from "./DeRepartizat.ts?vue&type=script&lang=ts&"
import style0 from "./DeRepartizat.vue?vue&type=style&index=0&id=7a33c040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a33c040",
  null
  
)

export default component.exports
import {QTable,QSpace,QInput,QIcon,QCard,QCardSection,QSeparator,QBtn,QMenu,QTr,QTd} from 'quasar'
component.options.components = Object.assign({QTable,QSpace,QInput,QIcon,QCard,QCardSection,QSeparator,QBtn,QMenu,QTr,QTd}, component.options.components || {})
